import styled from "styled-components";

export const Container = styled.div`
margin-top: 21px;
display: flex;
width: 100%;
flex-wrap:wrap;
margin-bottom: -9px;
align-items: start;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`
export const Image = styled.img`
    width: 98px;
    height: 98px;
    border-radius: 10px;
    border: 1px solid #c5c5c5;  
    margin-right:15px
`
export const ADImage = styled.img`
    width: 668px;
    object-fit:contain;
    @media (max-width: 1524px) {
      width:95% !important;
    }  
    @media (max-width: 1124px) {
        width:90% !important;
      }  
`
export const H3 = styled.h3`
    color: #312d2d;
    font-size: 20px;
    margin-top: 12px;
    margin-right: 2px;
    font-weight: 600;
    font-family: work sans !important;
    span{
        color:#2196F3;
    }
    @media (max-width: 1124px) {
        font-size: 12px !important;
      }  

    @media (max-width: 794px) {
        font-size: 10px !important;
      } 
`